export const assetRMRK = {
  id: 8,
  height: 408735,
  data: {
    icon: "/imgs/icons/asset/rmrk.svg",
    about:
      "RMRK.app is a part of Kusama's broader NFT strategy and a way to abuse Kusama's system.remark extrinsic to write custom notes onto the chain in a standardized and structured way. $RMRK is the governance, staking, and collateral token.",
    links: [
      {
        name: "Website",
        url: "https://rmrk.app",
      },
      {
        name: "Twitter: @rmrkapp",
        url: "https://twitter.com/RmrkApp",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Twitter: @rmrkstatus",
        url: "https://twitter.com/rmrkstatus",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Telegram: Kanaria project",
        url: "https://t.me/kanaria_official",
        icon: "/imgs/icons/link-telegram.svg",
      },
      {
        name: "Telegram: RMRK in general",
        url: "https://t.me/rmrkapp",
        icon: "/imgs/icons/link-telegram.svg",
      },
      {
        name: "Subsocial",
        url: "https://app.subsocial.network/@rmrkapp",
        icon: "/imgs/icons/link-subsocial.svg",
      },
      {
        name: "Youtube",
        url: "https://www.youtube.com/channel/UCZ9dCwNm2aErxsYxDdm-AtQ",
        icon: "/imgs/icons/link-youtube.svg",
      },
      {
        name: "Discord",
        url: "https://discord.com/invite/SpNEQSSwWv",
        icon: "/imgs/icons/link-discord.svg",
      },
    ],
    governances: [
      {
        spaceLogo: "/imgs/icons/asset/governance-rmrk.svg",
        spaceName: "RMRK",
        projectName: "RMRK",
        link: "https://opensquare.io/space/rmrk",
      },
      {
        spaceLogo: "/imgs/icons/asset/governance-rmrk-curation.png",
        spaceName: "RMRK Curation",
        projectName: "RMRK",
        link: "https://opensquare.io/space/rmrk-curation",
      },
    ],
  },
};
